<template>
  <div>
    <navtab class="navTab"></navtab>
    <div class="order">
      <div>
        <div class="tab tab_title">
          <div>宝贝</div>
          <div>单价</div>
          <div>数量</div>
          <div></div>
        </div>
        <div class="tab tab_mes">
          <div>宝贝</div>
          <div>单价</div>
          <div>数量</div>
          <div>金额</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navtab from "./navtab";
export default {
  name: "orderappraise",
  components: {
    navtab: navtab
  },
  data() {
    return {};
  },
  mounted() {
    //console.log(this.$route.params.id);
    this.$axios({
        method:'get',
        url:this.$http+'/api/Shopping/OrderByID/'+this.$route.params.id
    }).then(res=>{
        //console.log(res)
    })
  },
  methods: {}
};
</script>
<style>
.order {
  width: 80%;
  min-height: 100px;
  margin: 20px auto;
  background: #fff;
  box-shadow: 0 0 10px rgba(92, 92, 92, 0.1);
}
.order > div {
  width: 788px;
  margin: 0 auto;
  min-height: 100px;
  padding: 40px 0;
}
.tab {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.tab > div {
  width: 20%;
  padding: 10px 0;
  font-size: 16px;
  flex-basis: 100%;
}
.tab_title > div {
  background: #f5f5f5;
  color: #565656;
  /* height: 100%; */
}
.tab > div:first-child {
  width: 40%;
}
</style>





// WEBPACK FOOTER //
// src/components/orderAppraise.vue